/*
 * @Author: Yun
 * @Date: 2023-11-29 15:52:42
 * @Last Modified by: Yun
 * @Last Modified time: 2023-11-30 10:14:02
 */
import React, { useEffect } from 'react'
import './index.less'

window.jwplayer.key = '44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK'

let video_player_second_page = null

const SecondPage = (props) => {
    useEffect(() => {
        video_player_second_page = setJWplayer(document.querySelector('#second_page_video'), {
            video: 'https://video.cgtn.com/news/2024-12-31/President-Xi-Jinping-delivers-2025-New-Year-Address-1zMHIWs7Kbm/video/wu_1ige68t1j1eg1pva3b61mlt17k2s/wu_1ige68t1j1eg1pva3b61mlt17k2s.mp4',
            poster: require('@images/greetings/videocover.jpg'),
        })
    }, [])

    // 播放器
    const setJWplayer = (dom, data, opt) => {
        console.log('second', dom, data, opt)

        opt = opt || {}
        let instance

        try {
            instance = window
                .jwplayer(dom)
                .setup({
                    file: data.video,
                    image: data.poster,
                    // skin: {
                    //     name: 'nk-player'
                    // },
                    stretching: 'fill',
                    width: '100%',
                    aspectratio: opt.ratio || '16:9',
                    androidhls: true,
                    primary: 'html5',
                    autostart: opt.autostart === 'true' ? true : false,
                    mute: opt.mute === 'true' ? true : false,
                    controls: opt.controls === 'false' ? false : true,
                    repeat: opt.repeat === 'true' ? true : false,
                    hlshtml: true,
                    base: process.env.PUBLIC_URL + '/jwplayer-8.12.5',
                    flashplayer: process.env.PUBLIC_URL + '/jwplayer-8.12.5/jwplayer.flash.swf',
                })
                .on('setupError', (e) => {
                    console.log('Setup Error...', e)
                })
                .on('play', () => {
                    props.closeSwiperPageVideo()
                    props.closeGreetingsPageVideo()
                    props.closeAudio()
                    opt.onPlay && opt.onPlay()
                })
        } catch (error) {
            console.error('Setup JWplayer: ' + error)
        }

        return instance
    }

    return (
        <div className="SecondPage">
            <div className="SecondPage-wrapper">
                <div className="SecondPage-video">
                    <div id={'second_page_video'}></div>
                </div>
            </div>
        </div>
    )
}

export default SecondPage
